import Layout from "./index.hbd"
export default Layout
